module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.showGrid) ? _c('div', {
    staticClass: "column all-start well well-sm no-shadow",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "column all-start prest-upload"
  }, [_c('div', {
    staticClass: "required-field prest-upload-input row-flex centered-start",
    class: {
      'has-error': _vm.errors.first('tipo de documento')
    }
  }, [_c('label', {
    staticClass: "f-required prest-upload-label",
    attrs: {
      "for": "tipo de documento"
    }
  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documento.tipo_documento),
      expression: "documento.tipo_documento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "name": "tipo de documento",
      "id": "tipo de documento"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.documentos), function(documento) {
    return _c('option', {
      domProps: {
        "value": documento
      }
    }, [_vm._v(_vm._s(documento.ds_tipo))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "required-field prest-upload-input row-flex centered-start",
    class: {
      'has-error': _vm.errors.first('arquivo')
    }
  }, [_c('label', {
    staticClass: "f-required prest-upload-label",
    attrs: {
      "for": "file"
    }
  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        size: _vm.tamanhoPermitido,
        mimes: _vm.tiposPermitidos
      }),
      expression: "{required: false, size: tamanhoPermitido, mimes: tiposPermitidos}"
    }],
    ref: "file",
    attrs: {
      "type": "file",
      "name": "arquivo",
      "id": "file",
      "accept": _vm.restricaoArquivo ? '.pdf, application/pdf' : '*'
    },
    on: {
      "change": _vm.handleFileUpload
    }
  }), _vm._v(" "), (_vm.analise.hasOwnProperty('analise')) ? _c('div', [_c('i', {
    class: 'fa' + (_vm.analise.analise.RESPOSTA === 'SIM' ? ' fa-check text-success' : ' fa-times text-danger'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.analise.analise.RESPOSTA == 'NÃO' ? 'Arquivo não classificado como documento fiscal' : 'Arquivo válido'))]) : _vm._e(), _vm._v(" "), (_vm.analisandoArquivo) ? _c('div', [_c('i', {
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Analisando arquivo...")]) : _vm._e(), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "prest-upload-input row-flex centered-start",
    attrs: {
      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
    }
  }, [_c('label', {
    staticClass: "prest-upload-label",
    attrs: {
      "for": "expirationDate"
    }
  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "ng-if": "!$ctrl.flagNovoDocumento",
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalStateForm"
    }
  }, [_c('datepicker', {
    attrs: {
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.documento.expirationDate),
      callback: function($$v) {
        _vm.$set(_vm.documento, "expirationDate", $$v)
      },
      expression: "documento.expirationDate"
    }
  })], 1)])]), _vm._v(" "), (_vm.restricaoArquivo) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n          Formato: "), _c('b', [_vm._v("PDF")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n          Tamanho máximo: "), _c('b', [_vm._v("4 MB")]), _vm._v(" "), (_vm.restricaoArquivo) ? _c('i', [_vm._v(" / 10 Mil Caracteres")]) : _vm._e()]), _vm._v(" "), (_vm.restricaoArquivo) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n          *Atenção: envie um documento "), _c('b', [_vm._v("nítido, legível e sem cortes")]), _vm._v(". O arquivo será analisado automaticamente por OCR; documentos borrados, escuros, tortos, com baixa resolução ou parcialmente ilegíveis podem "), _c('b', [_vm._v("não ser reconhecidos corretamente pelo sistema")]), _vm._v(".\n        ")]) : _vm._e(), _vm._v(" "), (_vm.analise.analise) ? _c('div', {
    staticClass: "prest-analise-ia-container row-flex centered-start"
  }, [(_vm.analise.analise.RESPOSTA === 'NÃO') ? _c('div', {
    staticClass: "prest-analise-ia-item row-flex centered-start"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Análise do arquivo: " + _vm._s(_vm.analise.analise.DESCRITIVO) + "\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start prest-upload-button-container",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [(!_vm.restricaoArquivo) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button",
      "id": "cmpt-upload-add"
    },
    on: {
      "click": _vm.adicionaDocumento
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok\n            ")]) : _vm._e(), _vm._v(" "), (_vm.restricaoArquivo && !_vm.analisandoArquivo && _vm.analise.hasOwnProperty('analise') && _vm.analise.analise.RESPOSTA === 'SIM') ? _c('div', [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button",
      "id": "cmpt-upload-add"
    },
    on: {
      "click": _vm.adicionaDocumento
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok\n              ")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button",
      "id": "cmpt-upload-cancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar\n            ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showGrid) ? _c('div', [_c('input', {
    attrs: {
      "type": "hidden",
      "id": "myField",
      "name": "myField",
      "value": ""
    }
  }), _vm._v(" "), (!_vm.disableAdd) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novoDocumento
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo documento")])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('thead', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")]), _vm._v(" "), (!_vm.disable) ? _c('td', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.documentTypes), function(pendente) {
    return (!_vm.existeDocumento(pendente)) ? _c('tr', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('td', [_vm._v(_vm._s(pendente.type))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [(!_vm.disable) ? _c('button', {
      staticClass: "btn btn-primary btn-sm btn-flat btn-block",
      staticStyle: {
        "max-width": "135px",
        "text-align": "center"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.onAddFile(pendente)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Adicionar arquivo")]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
    return _c('tr', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('td', [_vm._v(_vm._s(documento.tipo_documento.ds_tipo))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "ng-binding",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.onDownload(documento)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_criado, 'DD/MM/YYYY')))]), _vm._v(" "), (!_vm.disable) ? _c('td', [(!_vm.disable) ? _c('button', {
      staticClass: "btn btn-danger btn-sm btn-flat",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletaDocumento(indexDocumento, documento)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")]) : _vm._e()]) : _vm._e()])
  })], 2)])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Pendente")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-105613d3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/prestacaoContasSimplificado/uploadDocumentosPhpPrestacao.vue
// module id = 1865
// module chunks = 1